"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="finalcalltoaction" data-nav="light" ref={ref} className="relative overflow-hidden bg-background py-20 md:py-28 lg:py-32 text-foreground">
      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center">
        <div className={`transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          <div className="mx-auto max-w-3xl">
            <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              Build a better understanding of how you move, perform and age
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-muted-foreground sm:text-xl">
              Measure your fitness, metabolism, gait and balance with PhysAnalytica, and use objective information to help guide your next steps.
            </p>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-5">
              <Button asChild size="lg" className="w-full sm:w-auto shadow-sm">
                <Link to="/BookNowPage">Book or Enquire</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
                <Link to="#assessment-pathway">Explore Longevity &amp; Fitness</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}